var _classCallCheck = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Declaration = require('../declaration');

var _require = require('./grid-utils'),
    prefixTrackProp = _require.prefixTrackProp,
    prefixTrackValue = _require.prefixTrackValue,
    autoplaceGridItems = _require.autoplaceGridItems,
    getGridGap = _require.getGridGap,
    inheritGridGap = _require.inheritGridGap;

var Processor = require('../processor');

var GridRowsColumns = /*#__PURE__*/function (_Declaration) {
  "use strict";

  _inherits(GridRowsColumns, _Declaration);

  var _super = _createSuper(GridRowsColumns);

  function GridRowsColumns() {
    _classCallCheck(this, GridRowsColumns);

    return _super.apply(this, arguments);
  }

  _createClass(GridRowsColumns, [{
    key: "prefixed",
    value:
    /**
     * Change property name for IE
     */
    function prefixed(prop, prefix) {
      if (prefix === '-ms-') {
        return prefixTrackProp({
          prop: prop,
          prefix: prefix
        });
      }

      return _get(_getPrototypeOf(GridRowsColumns.prototype), "prefixed", this).call(this, prop, prefix);
    }
    /**
     * Change IE property back
     */

  }, {
    key: "normalize",
    value: function normalize(prop) {
      return prop.replace(/^grid-(rows|columns)/, 'grid-template-$1');
    }
  }, {
    key: "insert",
    value: function insert(decl, prefix, prefixes, result) {
      if (prefix !== '-ms-') return _get(_getPrototypeOf(GridRowsColumns.prototype), "insert", this).call(this, decl, prefix, prefixes);
      var parent = decl.parent,
          prop = decl.prop,
          value = decl.value;
      var isRowProp = prop.includes('rows');
      var isColumnProp = prop.includes('columns');
      var hasGridTemplate = parent.some(function (i) {
        return i.prop === 'grid-template' || i.prop === 'grid-template-areas';
      });
      /**
       * Not to prefix rows declaration if grid-template(-areas) is present
       */

      if (hasGridTemplate && isRowProp) {
        return false;
      }

      var processor = new Processor({
        options: {}
      });
      var status = processor.gridStatus(parent, result);
      var gap = getGridGap(decl);
      gap = inheritGridGap(decl, gap) || gap;
      var gapValue = isRowProp ? gap.row : gap.column;

      if ((status === 'no-autoplace' || status === true) && !hasGridTemplate) {
        gapValue = null;
      }

      var prefixValue = prefixTrackValue({
        value: value,
        gap: gapValue
      });
      /**
       * Insert prefixes
       */

      decl.cloneBefore({
        prop: prefixTrackProp({
          prop: prop,
          prefix: prefix
        }),
        value: prefixValue
      });
      var autoflow = parent.nodes.find(function (i) {
        return i.prop === 'grid-auto-flow';
      });
      var autoflowValue = 'row';

      if (autoflow && !processor.disabled(autoflow, result)) {
        autoflowValue = autoflow.value.trim();
      }

      if (status === 'autoplace') {
        /**
         * Show warning if grid-template-rows decl is not found
         */
        var rowDecl = parent.nodes.find(function (i) {
          return i.prop === 'grid-template-rows';
        });

        if (!rowDecl && hasGridTemplate) {
          return undefined;
        } else if (!rowDecl && !hasGridTemplate) {
          decl.warn(result, 'Autoplacement does not work without grid-template-rows property');
          return undefined;
        }
        /**
         * Show warning if grid-template-columns decl is not found
         */


        var columnDecl = parent.nodes.find(function (i) {
          return i.prop === 'grid-template-columns';
        });

        if (!columnDecl && !hasGridTemplate) {
          decl.warn(result, 'Autoplacement does not work without grid-template-columns property');
        }
        /**
         * Autoplace grid items
         */


        if (isColumnProp && !hasGridTemplate) {
          autoplaceGridItems(decl, result, gap, autoflowValue);
        }
      }

      return undefined;
    }
  }]);

  return GridRowsColumns;
}(Declaration);

GridRowsColumns.names = ['grid-template-rows', 'grid-template-columns', 'grid-rows', 'grid-columns'];
module.exports = GridRowsColumns;